import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import classNames from 'classnames'
import { SuccessAlert } from 'components/alerts'
import Link from 'components/link'
import { contactUsPath } from 'lib/urls'
import InstallExtensionButton from 'shared/add-babylist-button/install-extension-button'
import { getBabylistExtensionInstalled } from 'registry/reducers'
import { InstallExtensionInstructions } from 'shared/add-babylist-button'
import OffsiteSymbol from 'shared/svg/offsite.svg'
import Image from 'components/image'
import css from './install-babylist-extension.scss'
import { ModalHeader } from 'react-bootstrap'

const InstallBabylistExtension = (props) => {
  const { storeName, storeUrl, onHide, installedBabylistExtension } = props

  return (
    <div className={css.modal}>
      <ModalHeader closeButton onHide={onHide} className={css.modalTitle}>
        <div className={css.headerText}>
          Add the Babylist Button to your browser
        </div>
      </ModalHeader>
      {installedBabylistExtension && (
        <SuccessAlert>
          It looks like you successfully installed the Babylist extension. Go
          add items from your favorite stores!
        </SuccessAlert>
      )}
      <div>
        <p className={css.infoText}>
          Install this Chrome extension to make it easy to add items to your
          registry from anywhere on the web.
        </p>
        <InstallExtensionInstructions className={css.mainImage} />
        <div className={css.actionItems}>
          <InstallExtensionButton
            className={classNames(
              'animated bounce delay-4500ms',
              css.installButton
            )}
            showChromeLogo={false}
            buttonText="Add to Chrome"
          />
          {!!storeName && (
            <Link className={css.storeLink} newWindow url={storeUrl}>
              Visit {storeName}
              <OffsiteSymbol className={css.offsiteSymbol} />
            </Link>
          )}
        </div>
      </div>
    </div>
  )
}

const mapStateToProps = (state) => ({
  installedBabylistExtension: getBabylistExtensionInstalled(state),
})

export default connect(mapStateToProps)(InstallBabylistExtension)
